import React from 'react'
import {fetchConnect, withToggles} from 'startlibs/lib/hocs'
import {setReport} from '../reducers'
import {Fill} from 'react-slot-fill'
import {ReportEditorHeader} from './ReportEditorHeader'
import {ReportHeader} from './ReportHeader'
import {ReportTitle} from './ReportTitle'
import {postFetcher} from 'startlibs'
import {ReportBasicInfo} from './ReportBasicInfo'
import {ReportFields} from './ReportFields'
import {ReportSignatures} from './ReportSignatures'
import {ReportViewerHeader} from './ReportViewerHeader'
import {ReportPreview} from './ReportPreview'
import {changeTemplate} from 'report-components/lib/reducers'
import {ReportNavbar} from './ReportNavbar'
import {ReportFooter} from './ReportFooter'
import {queryHasValue} from '../lib'
import {ReportKeyImagesLoader, ReportKeyImagesPanel} from './ReportKeyImages'

@fetchConnect(({user, report, appUI}) => ({
  isPreviewOpen: report.isPreviewOpen,
  isReportFinished: report.finished,
  readOnly: report.readOnly,
  userEmail:user.email,
  isChangingTemplate: appUI.loadings[changeTemplate]
}),{connectFetcher:setReport})
export class Report extends React.Component {

  render() {
    const {readOnly, isChangingTemplate, location, isReportFinished, isPreviewOpen} = this.props
    const showView = isPreviewOpen || isReportFinished || readOnly
    const isEmbedded = queryHasValue(location.search,'embedded',"true")
    return (
      <React.Fragment>
        <Fill name='Navbar-Center'>
          <ReportNavbar navigationDisabled={isEmbedded}/>
        </Fill>
        {
            showView ?
            <ReportViewer isEmbedded={isEmbedded}/> :
            <ReportEditor isEmbedded={isEmbedded} isChangingTemplate={isChangingTemplate}/>
        }
        {
          !isReportFinished && !readOnly &&
          <ReportKeyImagesLoader/>
        }
        <ReportFooter navigationDisabled={isEmbedded}/>
      </React.Fragment>
    )
  }
}

@withToggles('dragging')
class ReportEditor extends React.PureComponent {

  postFetcher = (formData) => postFetcher('t', formData)

  setDragging = (element) => {
    this.props.dragging.toggle(!!element)
  }

  render() {
    const {isChangingTemplate, isEmbedded, dragging} = this.props
    return <div className="content viva-report-builder">
      <ReportEditorHeader/>
      <div className={'report-page' + (isChangingTemplate ? ' loading' : '')}>
        <ReportHeader isEmbedded={isEmbedded}/>
        <ReportTitle/>
        <ReportBasicInfo setDragRef={this.setDragging}/>
        <ReportFields setDragRef={this.setDragging}/>
        <ReportSignatures isEmbedded={isEmbedded} setDragRef={this.setDragging}/>
      </div>
      <ReportKeyImagesPanel dragging={dragging}  />
    </div>
  }

}

class ReportViewer extends React.PureComponent {
  render() {
    const {isEmbedded} = this.props
    return (
      <div className="content viva-report-preview">
        <ReportViewerHeader
          hideSavePdfButton={isEmbedded}
        />
        <ReportPreview />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/report/Report.jsx